import React from 'react';
import {ShippingItemShippingMethod} from './ShippingItemShippingMethod';

export const ShippingItem = ({lastItem, item, shippingMethods, fee, showShippingMethods}) => (
  <div className={`row fix-spacing ${!lastItem ? 'margin-bottom' : ''}`}>
    <ShippingItemImage desktopImage={item.desktopImage} mobileImage={item.mobileImage}
                       productName={item.productName}/>
    <ShippingItemDetails item={item}/>
    {showShippingMethods &&
    <ShippingItemShippingMethods fee={fee} item={item} shippingMethods={shippingMethods}/>
    }
  </div>
);

const ShippingItemImage = ({desktopImage, mobileImage, productName}) => (
  <div className="large-2 medium-2 small-2 columns">
    <img className="mobile-hide" width="90" src={desktopImage} alt={productName}/>
    <img className="desktop-hide tablet-hide" width="50" src={mobileImage} alt={productName}/>
  </div>
);

const ShippingItemDetails = (props) => {
  let removeItemButton;
  if (props.item.removeItemUrl !== null) {
    if (props.item.isBundled) {
      removeItemButton = <a href={props.item.removeItemUrl}
                            className="text-danger cart_quantity_delete" rel="nofollow"
                            onClick={(e) => {
                              const confirmed = window.confirm(window.trans('front.order.checkout.shipping_step._block._cart_bundle_item.remove_confirmation'));
                              if (!confirmed) {
                                e.preventDefault();
                              }
                              return confirmed;
                            }}>{window.trans('front.order.checkout.shipping_step._block._cart_item.remove_button')}</a>;
    } else {
      removeItemButton = <a href={props.item.removeItemUrl}
                            className="text-danger cart_quantity_delete" rel="nofollow"
                            onClick={(e) => {
                              const confirmed = window.confirm(window.trans('front.order.checkout.shipping_step._block._cart_bundle_item.remove_confirmation'));
                              if (!confirmed) {
                                e.preventDefault();
                              }
                              return confirmed;
                            }}>{window.trans('front.order.checkout.shipping_step._block._cart_item.remove_button')}</a>;
    }
  }

  return (
    <div className="large-5 medium-5 small-5 columns">
      <div className="bootstrap contents">
        <p className="product-name">
          <a href={props.item.productUrl}>
            <strong>{props.item.productName}</strong>
          </a>
        </p>
        <p>{props.item.deliveryLabel && window.trans('front.order.checkout.shipping_step._block._shipping_items.delivery_label', {
          '{{ period }}': props.item.deliveryLabel,
        })}</p>
        <div className="paragraph text-muted">
          {props.item.options &&
            <div>{props.item.options}</div>
          }
          <div dangerouslySetInnerHTML={{
            __html: window.trans('front.order.checkout.shipping_step._block._shipping_items.product_quantity', {
              '{{ qty }}': props.item.totalQuantity,
              '{{ label }}': props.item.productQuantityFormatted,
            }),
          }}/>
          {!props.item.isBundled &&
          <div className="price" dangerouslySetInnerHTML={{
            __html: window.trans('front.order.checkout.shipping_step._block._shipping_items.bundle_unit_price', {
              '{{ price }}': props.item.productUnitPriceFormatted,
            })
          }}/>
          }
          {!props.item.isBundled &&
          <div className="price" dangerouslySetInnerHTML={{
            __html: window.trans('front.order.checkout.shipping_step._block._shipping_items.product_price', {
              '{{ price }}': `<span class="text-orange">${props.item.productTotalPriceFormatted}</span>`,
            })
          }}/>
          }
          <p>{removeItemButton}</p>
        </div>
      </div>
    </div>
  );
}

const ShippingItemShippingMethods = ({fee, item, shippingMethods}) => {
  const noShippingMethodLabel = !fee.feesIncluded && fee.shippingMethodId === null ?
    <div dangerouslySetInnerHTML={{
      __html: window.trans('front.order.checkout.shipping_step._block._shipping_items.delivery_not_available', {
        '{{ phone_number }}': window.trans('front.phone.hotline_number'),
      }),
    }}/> :
    <p><strong
      dangerouslySetInnerHTML={{__html: window.trans('front.order.checkout.shipping_step._block._shipping_items.delivery_included')}}/>
    </p>;

  const shippingMethodList = item.shippingMethods
    .filter(shippingMethodId => !!shippingMethods[shippingMethodId])
    .map(shippingMethodId =>
      <ShippingItemShippingMethod key={shippingMethodId} fee={fee} item={item}
                                  shippingMethod={shippingMethods[shippingMethodId]}/>,
    );

  const shippingMethodComponent = item.shippingMethods.length === 0 ? noShippingMethodLabel : shippingMethodList;

  return (
    <div className="large-5 medium-5 small-5 columns">
      <div className="contents">
        {shippingMethodComponent}
      </div>
    </div>
  );
};
